import React from "react";
import { Grid, Icon, Label, Button, Popup } from "semantic-ui-react";
import moment from "moment";
import { getFullNameAndMatricule } from "utils/displayName";
import { dateDiff, getWaitingTime } from "utils/dateUtils";

const styles = {
	rowContainer: {
		backgroundColor: "#fff",
		padding: 10,
		boxShadow: "0px 9px 35px -23px rgba(148,148,148,1)",
		borderRadius: "4px",
		width: "100%",
		minHeight: 100,
		margin: "3px 13px",
	},

	column: {
		color: "#00917d",
		fontWeight: 600,
		fontSize: "0.9em",
		width: "40%",
	},

	columnButton: {
		color: "#00917d",
		fontWeight: 600,
		fontSize: "0.9em",
		width: "8%",
	},

	commentsList: {
		maxHeight: "120px",
		overflow: "auto",
		padding: "5px",
	},

	commentContainer: {
		margin: "3px 0",
		maxHeigth: "150px",
		border: "1px solid whitesmoke",
	},
	commentHeader: {
		display: "flex",
		justifyContent: "flex-end",
	},

	time: {
		color: "#d1b8b8",
		fontSize: "0.8em",
		textAlign: "right",
	},
	comment: {
		color: "black",
		width: "100%",
		backgroundColor: "white",
		borderRadius: "7px",
		padding: "0 7px",
	},
	who: {
		color: "rgb(0, 145, 125)",
		borderRadius: "3px",
		padding: "0px 5px",
		fontSize: "0.8em",
		textAlign: "right",
	},
};

const getRibbonColor = (folderHelp) => {
	switch (folderHelp.status) {
		case "INIT":
			return "black";
		case "NEW":
			return "yellow";
		case "SUPPORT":
			return "orange";
		case "REASSIGNED":
			return "black";
		case "DONE":
			return "brown";
		case "ASSIGNED":
			return "orange";
		case "PENDING":
			return "red";
		case "CANCELED":
			return "grey";
		case "CANCELEDBYSEC":
			return "grey";
		default:
			break;
	}
};

const getRibbonText = (folderHelp) => {
	switch (folderHelp.status) {
		case "INIT":
			return "En attente du document";
		case "NEW":
			return "En attente";
		case "SUPPORT":
			return `En cours de traitement par ${folderHelp.assigned_to ? folderHelp.assigned_to.first_name : ""} ${
				folderHelp.assigned_to ? folderHelp.assigned_to.last_name : ""
			}`;
		case "REASSIGNED":
			if (folderHelp.folder.code.startsWith("TEMP_")) {
				return `Traité et en attente de la venue du patient dans un centre`;
			}
			return `Traité et en attente de prélèvement ${folderHelp.assigned_to ? folderHelp.assigned_to.first_name : ""} ${
				folderHelp.assigned_to ? folderHelp.assigned_to.last_name : ""
			}`;

		case "DONE":
			return "Terminé";
		case "ASSIGNED":
			return `Assigné à ${folderHelp.assigned_to ? folderHelp.assigned_to.first_name : ""} ${
				folderHelp.assigned_to ? folderHelp.assigned_to.last_name : ""
			}`;
		case "PENDING":
			return "En attente d'un.e senior";
		case "CANCELED":
			return "Annulé par la préleveuse";
		case "CANCELEDBYSEC":
			return "Annulé par la secrétaire";
		default:
			break;
	}
};

const HelpFolderListItem = ({ folderHelp, item, total, goToFolderManager, openHistoricFolderHelpModal, canSee, postAssignToMe, support }) => {
	const clickToEnter = async (e) => {
		if (e !== undefined) e.preventDefault();
		if (folderHelp.status === "NEW" || folderHelp.status === "PENDING") await postAssignToMe(folderHelp.id);
		if (folderHelp.status === "NEW" || folderHelp.status === "ASSIGNED" || folderHelp.status === "PENDING") await support(folderHelp.folder.id);
		goToFolderManager(folderHelp.folder.id);
	};

	const getWaitingTimeFolderHelp = (folderHelp) => {
		return (
			<span style={{ padding: "0 4px" }}>
				{folderHelp.status === "DONE" ||
				folderHelp.status === "REASSIGNED" ||
				folderHelp.status === "CANCELED" ||
				folderHelp.status === "CANCELEDBYSEC"
					? getWaitingTime(folderHelp.created_at, folderHelp.updated_at)
					: getWaitingTime(folderHelp.created_at)}
			</span>
		);
	};

	const getWaitingTimeTvSecFolderHelp = (folderHelp) => {
		if (folderHelp.historics.filter((h) => h.status_to === "NEW").length > 0)
			return (
				<span style={{ padding: "0 4px" }}>
					{getWaitingTime(
						folderHelp.historics.filter((h) => h.status_to === "NEW")[0].created_at,
						folderHelp.historics.filter((h) => h.status_to === "REASSIGNED" || h.status_to === "CANCELED" || h.status_to === "CANCELEDBYSEC").length >
							0
							? folderHelp.historics.filter((h) => h.status_to === "REASSIGNED" || h.status_to === "CANCELED" || h.status_to === "CANCELEDBYSEC")[0]
									.created_at
							: null
					)}
				</span>
			);
	};
	const getSupportedSecretary = (folderHelp) => {
		return folderHelp.historics.filter((h) => h.status_to === "SUPPORT").length > 0
			? folderHelp.historics.filter((h) => h.status_to === "SUPPORT")[0].user
			: null;
	};

	const getColorWaitingTime = (folderHelp) => {
		if (folderHelp.historics.filter((h) => h.status_to === "NEW").length > 0) {
			const time =
				folderHelp.historics.filter((h) => h.status_to === "REASSIGNED").length > 0
					? dateDiff(
							folderHelp.historics.filter((h) => h.status_to === "NEW")[0].created_at,
							folderHelp.historics.filter((h) => h.status_to === "REASSIGNED")[0].created_at
					  )
					: dateDiff(folderHelp.historics.filter((h) => h.status_to === "NEW")[0].created_at);
			if (time.day > 0 || time.hour > 0 || time.min > 10) return "red";
			if (time.min > 2) return "orange";
			return "green";
		}
	};
	return (
		<Grid.Row style={{ ...styles.rowContainer }} key={`help-folder-${folderHelp?.id}`}>
			<Grid.Column mobile={7} tablet={7} computer={5} style={{ ...styles.column }}>
				{folderHelp.fromPreregister && (
					<div>
						<Label as="span" color="violet" ribbon>
							Pré-inscription
						</Label>
					</div>
				)}
				<div>
					<Label as="span" color={getRibbonColor(folderHelp)} ribbon>
						{getRibbonText(folderHelp)}
					</Label>
				</div>
				{(folderHelp.status === "NEW" || folderHelp.status === "PENDING") && (
					<div>
						<Label as="span" color="yellow" ribbon>
							File d'attente : {item} / {total}
						</Label>
					</div>
				)}
				<div>
					<Label as="span" style={{ backgroundColor: "darkslategray", color: "white" }} ribbon>
						Télésecrétariat : {getWaitingTimeTvSecFolderHelp(folderHelp)}
						<Label size="mini" circular color={getColorWaitingTime(folderHelp)} empty key={`color-${folderHelp.id}`} />
					</Label>
				</div>

				<div>
					<Label as="span" style={{ backgroundColor: "#00917d", color: "white" }} ribbon>
						Temps d'attente : {getWaitingTimeFolderHelp(folderHelp)}
					</Label>
				</div>

				{/* 	{folderHelp.urgent && (
					<div style={{ fontSize: "0.8em" }}>
						<Icon name="warning" style={{ color: "#ff0000" }} />
						Dossier urgent
					</div>
				)} */}
				<div>
					Dossier {folderHelp.folder.code}{" "}
					{!folderHelp.fromPreregister && (
						<Popup
							content={
								folderHelp.comments.filter((c) => c.comment && c.comment.endsWith("Document associé automatiquement")).length > 0
									? "Document associé automatiquement"
									: "Le document n'a pas pu être associé automatiquement"
							}
							trigger={
								<Icon
									name="file"
									color={
										folderHelp.comments.filter((c) => c.comment && c.comment.endsWith("Document associé automatiquement")).length > 0
											? "green"
											: "grey"
									}
								/>
							}
						/>
					)}
				</div>
				{/* {folderHelp.folder && folderHelp.folder.patient && <div> {getFullNameAndMatricule(folderHelp.folder.patient)} </div>} */}
				{folderHelp.folder && folderHelp.folder.patient && (
    				<div
       					style={{
            				color: getFullNameAndMatricule(folderHelp.folder.patient) === "Patient à associer au dossier" ? "red" : "black",
        				}}
    				>
        				{getFullNameAndMatricule(folderHelp.folder.patient)}
    				</div>
				)}
				{folderHelp.folder && !folderHelp.folder.patient && folderHelp.folder.labAppointment && folderHelp.folder.labAppointment.patient && (
					<div> {getFullNameAndMatricule(folderHelp.folder.labAppointment.patient)} </div>
				)}
				{!folderHelp.fromPreregister && folderHelp.created_by && (
					<div style={{ fontSize: "0.9em" }}>
						Demandé par : {folderHelp.created_by ? folderHelp.created_by.first_name : ""}{" "}
						{folderHelp.created_by ? folderHelp.created_by.last_name : ""}
					</div>
				)}
				{folderHelp.folder?.labAppointment && folderHelp.folder?.labAppointment?.center && (
					<div style={{ fontSize: "0.9em" }}>
						Centre : {folderHelp.folder?.labAppointment?.center.name}{" "}
						{folderHelp.folder?.labAppointment?.center.tel && folderHelp.folder?.labAppointment?.center.tel !== "" && (
							<Label
								circular
								color="blue"
								size="mini"
								onClick={() => window.open(`tel:${folderHelp.folder?.labAppointment?.center.tel}`)}
								style={{ cursor: "pointer" }}
							>
								<Icon name="call" style={{ margin: 0 }} />
							</Label>
						)}
					</div>
				)}
				{getSupportedSecretary(folderHelp) && (
					<div style={{ fontSize: "0.9em" }}>
						Traité par : {getSupportedSecretary(folderHelp).first_name} {getSupportedSecretary(folderHelp).last_name}
					</div>
				)}
				{folderHelp.fromPreregister && folderHelp.folder && folderHelp.folder.preregister && (
					<div style={{ fontSize: "0.9em" }}>QR Code : {folderHelp.folder.preregister.qr_code}</div>
				)}

				{folderHelp.created_by && <div style={{ fontSize: "0.9em" }}>Créé le : {moment(folderHelp.created_at).format("DD/MM/YYYY[ à ]HH:mm")}</div>}
			</Grid.Column>
			<Grid.Column mobile={5} tablet={6} computer={8} style={{ ...styles.column }}>
				{folderHelp.comments && folderHelp.comments.filter((c) => c.manual).length > 0 && (
					<div>
						<div>Commentaires : </div>
						<div style={{ ...styles.commentsList }}>
							{folderHelp.comments
								.filter((c) => c.manual)
								.slice()
								.sort((a, b) => moment(b.created_at).diff(moment(a.created_at)))
								.map((c) => (
									<div style={{ ...styles.commentContainer }} key={`commenthf-${c.id}`}>
										{c.cancellation && c.cancelReason && (
											<Label ribbon>
												<span style={{ fontSize: "0.9rem" }}>Annulation de la demande de télésecrétariat : </span>
												{c.cancelReason.label}
											</Label>
										)}
										<div style={{ ...styles.commentHeader }}>
											{c.created_by && (
												<span style={{ ...styles.who }}>
													{c.created_by.first_name} {c.created_by.last_name}
												</span>
											)}
											<span style={{ ...styles.time }}>
												{moment(c.created_at).format(`${process.env.REACT_APP_DATE_DISPLAY_FORMAT}, ${process.env.REACT_APP_TIME_DISPLAY_FORMAT}`)}
											</span>
										</div>
										<div style={styles.comment}>
											<div style={{ ...styles.commentText }}> {c.comment}</div>
										</div>
									</div>
								))}
						</div>
					</div>
				)}
			</Grid.Column>

			<Grid.Column mobile={4} tablet={3} computer={3} style={{ ...styles.columnButton }}>
				<div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", height: "150px" }}>
					{openHistoricFolderHelpModal && (
						<Button
							basic
							color="teal"
							onClick={(e) => {
								if (e !== undefined) e.preventDefault();
								openHistoricFolderHelpModal(folderHelp);
							}}
						>
							<Icon name="history" /> Historique
						</Button>
					)}
					{((folderHelp.status === "PENDING" && canSee) || (folderHelp.status === "ASSIGNED" && canSee)) && (
						<Button color="orange" onClick={clickToEnter}>
							Prendre en charge
						</Button>
					)}
					{folderHelp.status === "SUPPORT" && canSee && (
						<Button color="orange" onClick={clickToEnter}>
							Ouvrir
						</Button>
					)}
				</div>
			</Grid.Column>
		</Grid.Row>
	);
};

export default HelpFolderListItem;
